<template>
  <div class="spaced-row">
    <div>
      <mad-form-item label="Location name">
        <mad-input v-model="form.name" />
      </mad-form-item>
      <mad-form-item label="Courtesy text">
        <mad-input v-model="form.courtesy_text" />
      </mad-form-item>
      <mad-form-item label="Background color">
        <color-input v-model="form.background_color" />
      </mad-form-item>
      <mad-form-item label="Button color">
        <color-input v-model="form.button_color" />
      </mad-form-item>
      <mad-form-item label="Button text color">
        <color-input v-model="form.button_text_color" />
      </mad-form-item>
      <mad-form-item label="Free color">
        <color-input v-model="form.free_color" />
      </mad-form-item>
      <mad-form-item label="Coffee color">
        <color-input v-model="form.coffee_color" />
      </mad-form-item>
      <mad-form-item label="Courtesy color">
        <color-input v-model="form.courtesy_color" />
      </mad-form-item>
      <mad-form-item label="Coffee image">
        <image-input v-model="form.coffee_image" />
      </mad-form-item>
      <mad-form-item label="Logo">
        <image-input v-model="form.logo" />
      </mad-form-item>
      <mad-form-item label="Logo placement">
        <image-placement-input v-model="form.logo_placement" />
      </mad-form-item>
    </div>
    <div class="preview">
      <iframe class="iframe" :src="iframeSrc"></iframe>
    </div>
  </div>
</template>

<script>
import ColorInput from './inputs/ColorInput'
import ImageInput from './inputs/ImageInput'
import ImagePlacementInput from './inputs/ImagePlacementInput'

export default {
  components: {
    ColorInput,
    ImageInput,
    ImagePlacementInput,
  },

  props: {
    form: { type: Object, default: null },
  },

  computed: {
    iframeSrc() {
      const baseUrl = process.env.VUE_APP_CLIENT_ENDPOINT + '/preview'
      const data = this.form
      const url =
        baseUrl +
        '?' +
        Object.entries(data)
          .map(keyVal => `${keyVal[0]}=${encodeURIComponent(keyVal[1])}`)
          .join('&')
      return url
    },
  },
}
</script>

<style lang="scss">
.preview {
  margin: 0 auto !important;
}

.iframe {
  height: 600px;
  width: 385px;
}
</style>
